<!-- 页脚 -->
<template>
  <div class="student-activity-footer" @click.stop>
    <span class="hidden-sm-and-down">*活动最终解释权归ENC Mobile所有 ｜</span>
    <span class="hidden-sm-and-up">*活动最终解释权归ENC Mobile所有</span>
    <span class="hidden-sm-and-down" style="margin-right: 10px">中国客服：400-990-6699</span>
    <span class="hidden-xs-only">美国客服：909-666-1188</span>
    <div class="title hidden-sm-and-up" @click="codeActived = null">
      <span style="margin-right: 10px">中国客服：400-990-6699</span>
      <span>美国客服：909-666-1188</span>
    </div>
    <span class="hidden-sm-and-up hidden-sm-and-down" @click="codeActived = null">
      迎客移动版权所有
    </span>
    <div class="hidden-sm-and-down" @click="codeActived = 0" @mouseenter="codeActived = 0">
      <img src="@/assets/images/students/wx.svg" alt="美国手机卡" class="wx" />
      <img
        v-if="codeActived === 0"
        src="@/assets/images/common/qrcode.png"
        alt="美国手机套餐"
        class="wx-code"
        :class="[$getDev() == 'pc' ? 'wx-code' : codeActived === 0 ? 'wx-code' : 'hide']" />
    </div>
    <div class="hidden-sm-and-down" @click="codeActived = 1" @mouseenter="codeActived = 1">
      <img src="@/assets/images/students/xhs.svg" alt="美国手机卡" class="xhs" />
      <img
        v-if="codeActived === 1"
        src="@/assets/images/students/xhs-code.svg"
        alt="美国手机套餐"
        class="xhs-code" />
    </div>
    <div class="imgStyle hidden-sm-and-up">
      <div>
        <img src="@/assets/images/25students/h5/footer1.png" alt="小红书" />
        <span>小红书</span>
      </div>
      <div>
        <img src="@/assets/images/25students/h5/footer2.png" alt="微信" />
        <span>微信</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeActived: ''
    };
  }
};
</script>
<style scoped lang="less">
@media (min-width: 768px) {
  .student-activity-footer {
    width: 100%;
    background: #fff5f5;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #6b6b6b;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 0;

    span :not(:last-child) {
      margin-right: 20px;
    }

    > div {
      position: relative;

      .wx-code,
      .xhs-code {
        display: none;
      }

      &:hover {
        .wx-code {
          display: block;
        }

        .xhs-code {
          display: block;
        }
      }
    }

    .wx,
    .xhs {
      position: relative;
      cursor: pointer;
    }

    .wx {
      margin: 0 17px 0 24px;
    }

    .wx-code,
    .xhs-code {
      width: 232px;
      height: auto;
      position: absolute;
      left: 48%;
      transform: translateX(-48%);
      top: -295.5px;
    }
    .wx-code {
      left: 48%;
      transform: translateX(-48%);
      top: -250px;
    }
    .xhs-code {
      left: 50%;
      transform: translateX(-50%);
      top: -285.5px;
    }
  }
}
@media (max-width: 767px) {
  .student-activity-footer {
    width: 100%;
    background: #fff5f5;
    font-weight: 500;
    font-size: 2.9333vw;
    line-height: 3.8667vw;
    padding: 9.2vw 0;
    padding-bottom: 2vw;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: auto;
    > span {
      color: #6b6b6b;
      font-family: OPPOSans;
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.032vw;
      text-transform: capitalize;
    }
    .title {
      margin-bottom: 2.1333vw;
      flex-basis: 100%;
      text-align: center;
      > span {
        color: #6b6b6b;
        font-family: OPPOSans;
        font-size: 3.2vw;
        font-style: normal;
        font-weight: 400;
        line-height: 2.6667vw; /* 83.333% */
        letter-spacing: 0.032vw;
        text-transform: capitalize;
      }
    }
    .imgStyle {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5vw;
      margin-top: 4vw;
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2vw;
        > img {
          width: 20.8vw;
          height: 20.8vw;
        }
        > span {
          color: #6b6b6b;
          text-align: center;
          font-family: 'PingFang SC';
          font-size: 3.2vw;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.032vw;
          text-transform: capitalize;
        }
      }
    }

    > div:not(.title) {
      position: relative;

      .hide {
        display: none;
      }

      .wx-code,
      .xhs-code {
        display: block;
      }
    }

    .wx,
    .xhs {
      position: relative;
      cursor: pointer;
    }

    .wx {
      margin: 0 3.2vw 0 2.1333vw;
    }

    .wx-code,
    .xhs-code {
      width: 30.9333vw;
      height: 37.9333vw;
      position: absolute;
      left: 52%;
      transform: translateX(-52%);
      top: -39.4vw;
    }

    .xhs-code {
      left: 50%;
      transform: translateX(-50%);
      top: -38.0667vw;
    }
  }
}
</style>
